import { ButtonDescription, ImageDescription, TextDescription } from "../../values/values.service";

export enum SetupStep {
    OnboardedStarted = 'onboarding_started',
    ServiceConnectStart = 'service_connect_start',
    ServiceConnectEnd = 'service_connect_end',
    ProtectDeviceStart = 'protect_device_start',
    ProtectDeviceEnd = 'protect_device_end',
    OnboardingFinished = 'onboarding_finished'
}

export interface LiveReportDataModel {
    emails_monitored: number;
    email_scans: number;
    emails_scanned: number;
    dangerous_emails_marked: number;
    devices_protected: number;
    team_members_protected: number;
    recommendations_resolved: number;
    threats_blocked: number;
    malicious_url_blocked: number;
    service_report?: ServiceReportModel;
    aggregated_service_report?: ServiceReportModel;
}

export interface ServiceReportModel {
    // Youtube
    video_count?: number;
    playlist_count?: number;
    // Facebook and instagram
    post_count?: number;
    dm_scanned?: number;

    // Common
    scan_count: number;
}

export interface IconInterface {
    type: string;
    value: string;
    color?: string;
    bg?: string;
}

export interface LiveReportFieldInterface {
    icon: IconInterface;
    label: string;
    value: number | string;
    id?: number;
}

export enum LiveReportField {
    EMAILS_MONITORED = 'emailsMonitored',
    THREATS_BLOCKED = 'threatsBlocked',
    VIDEOS_MONITORED = 'videosMonitored',
    EMAILS_SCANNED = 'emailsSCanned',
    DEVICES_PROTECTED = 'devicesProtected',
    TEAMS_PROTECTED = 'teamsProtected',
    SCANS = 'scans',
    DETECTING_MALICIOUS_URLS = 'detectingMaliciuosUrls',
    MARKING_DANGEROUS_EMAIL = 'markingDangerousEmails',
    FEATURE_PLAYLISTS = 'featurePlaylists',
    RECOMENDATIONS = 'recomendations',
    POSTS_MONITORED = 'postsMonitored',
    DM_SCANNED = 'dmScanned',
}

export type LiveReportInterface = {
    [key in LiveReportField]?: LiveReportFieldInterface;
}

export interface AtoReconnectFlowInterface {
    img: ImageDescription;
    title: TextDescription;
    desc: TextDescription;
    actionButton: ButtonDescription;
}

export type AtoReconnectInterface = {
    [key in ReconnectFlow]: AtoReconnectFlowInterface
}

export enum ReconnectFlow {
    CONNECT_YT_INFO = 'connectYoutubeInfo',
    CONNECT_IG_INFO = 'connectInstagramInfo',
    CONNECT_FB_INFO = 'connectFacebookInfo',
    CONNECT_YT_ERROR = 'connectYoutubeError',
    CONNECT_IG_ERROR = 'connectInstagramError',
    CONNECT_FB_ERROR = 'connectFacebookError',
    CONNECT_OK = 'connectOk',
    SETUP_ERROR = 'setupError'
}


export enum AccountStatus {
    WITH_CRITICAL_RECOMENDATIONS = 'withCriticalRecomandations',
    WITH_RECOMENDATIONS = 'withRecomandations',
    GOOD = 'good'
}

export interface AccountStatusInterface {
    type: string;
    icon: string;
    color: string;
    bg?: string;
    figureClass?: string;
    iconBg?: string;
}

export type AtoAccountStatuses = {
    [key in AccountStatus]: AccountStatusInterface;
}

const _accountStatusType = "feedback-filled";
export const AccountStatusesInterface: AtoAccountStatuses = {
    [AccountStatus.WITH_CRITICAL_RECOMENDATIONS]: {
        type: _accountStatusType,
        icon: 'shield-attention',
        color: 'danger-5',
        bg: 'danger',
        figureClass: 'atRiskStatus',
        iconBg: 'danger-5'
    },
    [AccountStatus.WITH_RECOMENDATIONS]: {
        type: _accountStatusType,
        icon: 'shield',
        color: 'light',
        bg: 'dark',
        figureClass: 'toDoStatus',
        iconBg: 'shade-3'
    },
    [AccountStatus.GOOD]: {
        type: _accountStatusType,
        icon: 'shield-check',
        color: 'light',
        bg: 'a6-15',
        figureClass: 'goodStatus',
        iconBg: 'success-5'
    }
}
